export default "__VITE_ASSET__CHxaUsfC__"